<template>
  <button
    class="button"
    :class="
      classes
        ? `${classes} ${withoutBackground ? 'without-background' : ''}`
        : `${withoutBackground ? 'without-background' : ''}`
    "
    :style="`${width ? `width: ${width}` : ``}`"
    @click="handleClick"
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  props: ["label", "width", "height", "withoutBackground", "type", "classes"],
  emits: ["clicked"],
  data() {
    return {};
  },
  methods: {
    handleClick() {
      this.$emit("clicked");
    },
  },
};
</script>

<style scoped>
.button {
  border-radius: 50px;
  /* background: rgb(167, 214, 253); */
  height: 35px;
  color: #54514c;
  background: #c5c0b9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  text-transform: uppercase;
  width: 200px;
  cursor: pointer;
  transition: all .4s;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.withLetterSpacing {
  letter-spacing: 0.0892857143em;
}
.button:hover {
  /* background: rgb(139, 185, 223); */
  background: #E5E5E5;
}

.without-background {
  background: none;
  border: 1px solid rgba(0, 0, 0, 0.5);
}
.without-background:hover {
  background: #E5E5E5;
}
</style>
